import React, { Suspense } from 'react';
import * as Sentry from '@sentry/browser';
import MixPanel from 'mixpanel-browser';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer, Slide } from 'react-toastify';
import Routes from '~/routes';
import GlobalStyle from '~/layout/globalStyle';
import { configureStore } from '~/store/config';
import * as NuacomComponent from '~/components';
import * as config from '~/config/config';
import log from '~/helpers/log';
import packageJSON from '../package.json';
import 'react-toastify/dist/ReactToastify.css';

const isDEV = process.env.NODE_ENV === 'development';

// eslint-disable-next-line no-console
log.info(`app mode: ${process.env.NODE_ENV}`);

// Avoid Sentry to propagate this Chrome error.
// https://bit.ly/2Z3G3gq
window.addEventListener('error', e => {
  // Ignore ResizeObserver error
  if (e.message === 'ResizeObserver loop limit exceeded') {
    e.stopPropagation();
    e.stopImmediatePropagation();
  }
});

MixPanel.init(config.MIXPANEL_PROJECT_TOKEN, {
  api_host: config.MIXPANEL_PROJECT_API_HOST,
  track_pageview: false,
  persistence: 'localStorage',
  debug: !!isDEV,
});

Sentry.init({
  dsn: isDEV ? config.SENTRY_DSN_WEB_DEV : config.SENTRY_DSN_WEB_PROD,
  release: packageJSON.version,
  ignoreErrors: [
    'Non-Error promise rejection captured with value: Connection timeout',
    'ResizeObserver loop completed with undelivered notifications.',
    'ResizeObserver loop limit exceeded',
    'The play() request was interrupted by',
    // 'Invalid status: 8',
    // 'Invalid status: 9',
  ],
});

const { store, persistor } = configureStore();

export default function App() {
  return (
    <Suspense fallback="">
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <ToastContainer transition={Slide} />
          <GlobalStyle />

          <NuacomComponent.ErrorBoundary>
            {/* <NuacomComponent.TourProvider> */}
            <Routes />
            {/* </NuacomComponent.TourProvider> */}
          </NuacomComponent.ErrorBoundary>
        </PersistGate>
      </Provider>
    </Suspense>
  );
}
